import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { Home, Assessment, Person, Mail } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';

const athleteNav = [
  { label: 'ホーム', icon: <Home />, path: '/athlete/dashboard' },
  { label: '診断', icon: <Assessment />, path: '/assessment' },
  { label: 'プロフィール', icon: <Person />, path: '/profile/view' },
  { label: 'メッセージ', icon: <Mail />, path: '/athlete/scouts' },
];

const companyNav = [
  { label: 'ホーム', icon: <Home />, path: '/company/dashboard' },
  { label: '検索', icon: <Assessment />, path: '/company/search' },
  { label: 'スカウト', icon: <Mail />, path: '/company/scouts' },
];

const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAthlete, isCompany } = useAuth();

  if (!user) return null;

  const navItems = isAthlete ? athleteNav : isCompany ? companyNav : [];
  if (navItems.length === 0) return null;

  const currentIndex = navItems.findIndex((item) => location.pathname.startsWith(item.path));

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        display: { xs: 'block', md: 'none' },
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
      elevation={3}
    >
      <BottomNavigation
        value={currentIndex >= 0 ? currentIndex : false}
        onChange={(_, newValue) => {
          navigate(navItems[newValue].path);
        }}
        showLabels
        sx={{
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            padding: '6px 0',
            minHeight: 56,
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.625rem',
            '&.Mui-selected': {
              fontSize: '0.7rem',
            },
          },
        }}
      >
        {navItems.map((item) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
